<div class="points-img">
  <img class="img-fluid" src="assets/img/home-points.png" />
</div>
<div *ngIf="pointType === 'fsa'" class="point-container">
  <div class="d-flex justify-content-between align-items-center">
    <div class="heading d-inline-block">
      {{ "common.myPoints" | translate }}
    </div>
    <div
      *ngIf="showMoreDetails"
      class="d-block d-md-none more-detail"
      [routerLink]="['/point-history']"
      [queryParams]="{ point_type: 'all', point_category: 'all' }"
    >
      {{ "common.moreDetails" | translate }}
      <span class="ms-1" *ngIf="!lang.isRTL">
        <i class="fa fa-chevron-right"></i>
      </span>
      <span class="me-1" *ngIf="lang.isRTL">
        <i class="fa fa-chevron-left"></i>
      </span>
    </div>
    <div *ngIf="year?.start && year?.end" class="points-detail year-duration">
      {{ year?.start | date: "dd MMM yyyy" }} -
      {{ year?.end | date: "dd MMM yyyy" }}
    </div>
  </div>
  <div class="d-sm-flex justify-content-between mob-flex-col">
    <div
      class="d-flex justify-content-between cursor-pointer"
      [routerLink]="['/point-history']"
      [queryParams]="{ point_type: 'all', point_category: 'all' }"
      (click)="updateTransactions('all', 'all')"
    >
      <div class="d-flex align-items-center gap-3">
        <img
          class="img-fluid img-wallet float-start"
          src="assets/img/wallet-1.png"
        />
        <div class="d-flex flex-column">
          <div
            class="box-spinner-align"
            [ngClass]="this.appName == 'yara' ? 'cursor-pointer' : ''"
            (click)="this.appName == 'yara' ? openPointCalculations() : null"
          >
            <ng-container *ngIf="!loading">
              <span class="points">{{ pointsAvailable | number }}</span>
              <img class="yp-img d-none" src="assets/img/svg-icons/yp.svg" />
            </ng-container>
            <app-spinner *ngIf="loading"></app-spinner>
          </div>
          <div *ngIf="showPointsOnHome.available" class="box-spinner-align">
            <div class="points-detail">
              {{ "common.pointsAvailableForRedemption" | translate }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Commenting for now, since BE changes for MSA are not released yet. -->
    <!-- <div
      *ngIf="!showMsaInTabView && showMsaPoints"
      class="d-flex justify-content-between"
    >
      <div class="d-flex align-items-center gap-3">
        <img
          class="img-fluid img-wallet float-start"
          src="assets/img/msa-icon.svg"
        />
        <div class="d-flex flex-column">
          <div class="box-spinner-align">
            <span *ngIf="!msaCreditLoading" class="points">{{ msaPoints ? (msaPoints | number) : 0 }}</span>
            <app-spinner *ngIf="msaCreditLoading"></app-spinner>
          </div>
          <div class="box-spinner-align">
            <div class="points-detail">
              {{ "common.msaAvailable" | translate }}
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <div class="d-flex justify-content-end gap-2">
      <div
        *ngIf="syncPoints && showMoreDetails"
        class="more-detail ms-2"
        (click)="syncUserPoints.emit()"
      >
        {{ "common.syncPoints" | translate }}
        <img class="points--reload" src="assets/img/reload.png" />
      </div>
      <div
        *ngIf="showMoreDetails"
        class="d-none d-md-block more-detail"
        [routerLink]="['/point-history']"
        [queryParams]="{ point_type: 'all', point_category: 'all' }"
      >
        {{
          msaPoints
            ? ("common.more._" | translate)
            : ("common.moreDetails" | translate)
        }}
        <span class="ms-1" *ngIf="!lang.isRTL">
          <i class="fa fa-chevron-right"></i>
        </span>
        <span class="me-1" *ngIf="lang.isRTL">
          <i class="fa fa-chevron-left"></i>
        </span>
      </div>
    </div>
  </div>
  <div
    *ngIf="!loading && ((showMsaPoints && showMsaInTabView) || !showMsaPoints)"
    class="row g-2 mt-3"
  >
    <div
      *ngIf="showPointsOnHome.pointsAtStartOfYear && year?.value"
      class="col-4"
      [routerLink]="['/point-history']"
      [queryParams]="{ point_type: 'all', point_category: 'all' }"
      (click)="updateTransactions('all', 'all')"
    >
      <div class="d-flex flex-column point-type-container px-2 py-3">
        <div class="point-type-points">
          {{ pointsAtTheStartOfYear | number }}
        </div>
        <div class="point-type-details">
          {{ "common.pointsAtStartOfYear" | translate }}
        </div>
      </div>
    </div>
    <div
      *ngIf="showPointsOnHome.earned"
      [ngClass]="
        showPointsOnHome.pointsAtStartOfYear && year?.value ? 'col-4' : 'col-6'
      "
      [routerLink]="['/point-history']"
      [queryParams]="{ point_type: 'earned', point_category: 'all' }"
      (click)="updateTransactions('earned', 'all')"
    >
      <div class="d-flex flex-column point-type-container px-2 py-3">
        <div class="point-type-points">
          {{ pointsEarned | number }}
        </div>
        <div class="point-type-details">
          {{ "common.totalPointsEarned" | translate }}
        </div>
      </div>
    </div>
    <div
      *ngIf="showPointsOnHome.redeemed"
      [ngClass]="
        showPointsOnHome.pointsAtStartOfYear && year?.value ? 'col-4' : 'col-6'
      "
      [routerLink]="['/point-history']"
      [queryParams]="{ point_type: 'used', point_category: 'all' }"
      (click)="updateTransactions('used', 'all')"
    >
      <div class="d-flex flex-column point-type-container px-2 py-3">
        <div class="point-type-points">
          {{ pointsUsed | number }}
        </div>
        <div class="point-type-details">
          {{ "common.totalPointsRedeemed" | translate }}
        </div>
      </div>
    </div>
  </div>
  <div
    *ngIf="
      !loading &&
      ((showMsaPoints && showMsaInTabView) || !showMsaPoints) &&
      showPointsOnHome.showExpiringPoints
    "
    class="row mt-3"
  >
    <div
      class="col-12"
      [routerLink]="['/point-history']"
      [queryParams]="{ point_type: 'expiring', point_category: 'all' }"
      (click)="updateTransactions('expiring', 'all')"
    >
      <div
        class="d-flex justify-content-between align-items-center point-type-container p-2"
      >
        <div class="points-expiring">
          {{ expiryPointsText }}
        </div>
        <div class="point-type-points">
          {{ pointsExpiringThisMonth | number }}
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Commenting for now, since BE changes for MSA are not released yet. -->
<!-- <div *ngIf="pointType === 'msa'" class="point-container">
  <div *ngIf="year?.start && year?.end" class="points-detail justify-self-end">
      {{ year?.start | date: "dd MMM yyyy" }} -
      {{ year?.end | date: "dd MMM yyyy" }}
    </div>
  <div class="d-flex justify-content-between mob-flex-col">
    <div class="d-flex justify-content-between w-100 mb-2">
      <div class="d-flex align-items-center gap-3">
        <img
          class="img-fluid img-wallet float-start"
          src="assets/img/msa-icon.svg"
        />
        <div class="d-flex flex-column">
          <div class="box-spinner-align">
            <span class="points">{{ msaPoints | number }}</span>
            <app-spinner *ngIf="loading"></app-spinner>
          </div>
          <div class="box-spinner-align">
            <div class="points-detail">
              {{ "common.msaAvailable" | translate }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-end w-100 gap-3">
      <div class="d-flex flex-column point-type-container w-100 px-2 py-3">
        <div class="point-type-points">
          {{ msaPointsEarned | number }}
        </div>
        <div class="point-type-details">
          {{ "common.totalPointsEarned" | translate }}
        </div>
      </div>
      <div class="d-flex flex-column point-type-container w-100 px-2 py-3">
        <div class="point-type-points">
          {{ msaPointsUsed | number }}
        </div>
        <div class="point-type-details">
          {{ "common.msaUtilized" | translate }}
        </div>
      </div>
    </div>
  </div>
</div> -->
